export const ValidEmailRegex = new RegExp(
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i,
)
export const ValidUrlRegex = new RegExp(
  /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/i,
)

export const ProfilePhotoFileExtractionRegex = new RegExp(/^https:\/\/.*\/([a-zA-Z0-9\.\_\-\s]+.*)$/i)

export const GetFilenameRegex = new RegExp(/^https:\/\/.*\/([a-zA-Z0-9\.\_\-\s]+.*)$/i)

export const RemoveQueryStringsRegex = new RegExp(/^([^&#]+).*/i)
